import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LandingPageState {
  id: string | null;
  description: string;
  contentUrl: string;
  needRefresh: boolean;
}

const initialState: LandingPageState = {
  id: null,
  description: "",
  contentUrl: "",
  needRefresh: true,
};

const landingPageSlice = createSlice({
  name: "landingPage",
  initialState,
  reducers: {
    setLandingPageData: (
      state,
      action: PayloadAction<{
        id: string;
        description: string;
        contentUrl: string;
      }>
    ) => {
      state.id = action.payload.id;
      state.description = action.payload.description;
      state.contentUrl = action.payload.contentUrl;
      state.needRefresh = false;
    },
    setLandingPageNeedRefresh: (state, action: PayloadAction<boolean>) => {
      state.needRefresh = action.payload;
    },
  },
});

export const { setLandingPageData, setLandingPageNeedRefresh } =
  landingPageSlice.actions;
export default landingPageSlice.reducer;
